
import {initWebComponent} from "@/helpers/web-component-helper";

export class FooterButtonComponent extends HTMLElement {
    constructor(){
        super();

        const icon = this.getAttribute('data-icon')
        let title = this.getAttribute('data-title')
        let text = this.getAttribute('data-text')
        if(text === null) {
            text = ''
        }

        const template = document.createElement('template');
        template.innerHTML = `<button class="btn btn-outline-secondary icon-btn btn-footer btn-lg ml-1 popper-header">
              <span class="` + icon + ` button-footer-text"></span> ` + text + `
              <div class="popper-tooltip" role="tooltip">
                      ` + title + `
                <div class="arrow" data-popper-arrow=""></div>
              </div>
        </button>`;

        initWebComponent(this, template)
    }
}

